import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { BussinessDocumentsResolutionStatusEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoicingRequestModel } from 'src/app/models/invoicing/invoicing-request.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { InvoicingCutoffService } from 'src/app/services/invoicing/invoicing-cutoff.service';
import { BussinessDocumentsResolutionService } from 'src/app/services/management/bussiness-documents-resolution.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';


@Component({
  selector: 'app-invoice-invoicing-cutoff',
  templateUrl: './invoice-invoicing-cutoff.component.html',
  styleUrls: ['./invoice-invoicing-cutoff.component.scss'],
  standalone: false
})
export class InvoiceInvoicingCutoffComponent implements OnInit {

  branchName: string = "";
  bussinessDocumentsTypeId: number = 0;
  enterpriseId: number = 0;
  dateExpiration: string = '';
  daysExpiration: number = 0;
  disabledToInvoice: boolean = false;
  formInvoiceInvoicingCutoff: FormGroup = new FormGroup({});
  invoicingCutoffCode: string = "";
  invoicingCutoffId: number = 0;
  invoicingRequestModel: InvoicingRequestModel = new InvoicingRequestModel();
  movementToInvoice: Array<number> = new Array<number>();
  quantityCostCenterTypeThird: number = 0;
  suscription: Subscription;
  swElectronicInvoice: boolean = false;
  updateRegister: boolean = false;

  constructor(private bussinessDocumentsResolutionService: BussinessDocumentsResolutionService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private companyService: CompanyService,
    public config: DynamicDialogConfig,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private invoicingCutoffService: InvoicingCutoffService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,) {
    this.validateForm(this.invoicingRequestModel);
    this.getCompanyByUserAutheticated()
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.enterpriseId = inputs.enterpriseId;
      this.invoicingCutoffId = inputs.invoicingCutoffId;
      this.branchName = inputs.branchName;
      this.invoicingCutoffCode = inputs.invoicingCutoffCode;
      this.quantityCostCenterTypeThird = inputs.quantityCostCenterTypeThird;
      this.swElectronicInvoice = inputs.swElectronicInvoice;
      this.movementToInvoice = inputs.movementToInvoice;
    });
    // await this.getFirstBussinessDocumentsType();
  }

  addDaysToDate(days: number | null) {
    if (days != null) {
      this.formInvoiceInvoicingCutoff.controls["invoiceExpirationDays"].patchValue(days);
      const dateInvoicing = new Date(this.formInvoiceInvoicingCutoff.get("dateInvoicing")?.value);
      const dateExpiration = moment(dateInvoicing).add(days, 'days');
      this.dateExpiration = (dateExpiration.format('DD-MM-YYYY'));
    }
  }

  changeDayExpiration() {
    const days = this.formInvoiceInvoicingCutoff.get("invoiceExpirationDays")?.value;
    this.addDaysToDate(days as number);
  }

  close() {
    const data: ModalObjectType = {};
    if (this.updateRegister) {
      data.params = { reload: true };
      this.updateRegister = false;
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async getCompanyByUserAutheticated() {
    try {
      const response = await firstValueFrom(this.companyService.getCompanyByUserAutheticated());
      this.daysExpiration = response.invoiceExpirationDays;
      this.addDaysToDate(this.daysExpiration);
    } catch (error) {
      console.error('Error al obtener la empresa del usuario autenticado.', error);
    }
  }

  async invoiceInvoicingCutoff() {
    const accepted = await this.confirmDialogService.confirm("¿Realmente desea correr el proceso de facturación?");
    if (accepted) {
      this.disabledToInvoice = true;
      if (this.formInvoiceInvoicingCutoff.valid) {
        this.updateRegister = true;
        const modelInvoice = this.formInvoiceInvoicingCutoff.value as InvoicingRequestModel;
        modelInvoice.invoicingCutoffId = this.invoicingCutoffId;
        modelInvoice.movementToInvoice = this.movementToInvoice;
        const shouldValidateResolution = (this.quantityCostCenterTypeThird > 0) && this.swElectronicInvoice;
        if (shouldValidateResolution) {
          if (!await this.validateResolutionExpiration(modelInvoice.dateInvoicing)) {
            return;
          }
        }
        try {
          await firstValueFrom(this.invoicingCutoffService.toInvoiceInvoicingCutoffById(modelInvoice));
          this.toastHandlerService.showToast('success', 'El proceso ha terminado exitosamente.');
          this.close();
        } catch (error) {
          console.error('Error al correr el proceso de facturación.', error);
        }
      };
    }
  }

  validateForm(invoicingRequestModel: InvoicingRequestModel) {
    this.formInvoiceInvoicingCutoff = this.formBuilder.group({
      dateInvoicing: [invoicingRequestModel.dateInvoicing ?
        this.dateConverterService.convertUtcToLocalDate(invoicingRequestModel.dateInvoicing) : null, [Validators.required]],
      invoiceExpirationDays: [invoicingRequestModel.invoiceExpirationDays, [Validators.required, Validators.min(0)]]
    });
  }

  async validateResolutionExpiration(dateInvoice: Date): Promise<boolean> {
    try {
      const status = await firstValueFrom(this.bussinessDocumentsResolutionService.getResolutionExpirationStatus(dateInvoice,
        this.enterpriseId));
      const messages: Partial<Record<BussinessDocumentsResolutionStatusEnums, { type: 'warning' | 'error'; text: string }>> = {
        [BussinessDocumentsResolutionStatusEnums.aboutToExpire]: {
          type: 'warning',
          text: 'La resolución está por vencer (faltan 2 días o menos).',
        },
        [BussinessDocumentsResolutionStatusEnums.expired]: {
          type: 'error',
          text: 'La resolución ha vencido. No se puede continuar.',
        },
      };
      const message = messages[status as BussinessDocumentsResolutionStatusEnums];
      if (message) { this.toastHandlerService.showToast(message.type, message.text); }
      return status !== BussinessDocumentsResolutionStatusEnums.expired;
    } catch (error) {
      console.error('Error al validar la vigencia de la resolución.', error);
      return false;
    }
  }
}
